import { FC, useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'

import { useAppDispatch } from 'hooks/store'
import useLoadingDelay from 'hooks/useLoadingDelay'
import { logOut } from 'share/utils/authenticationUtils'
import { SignOffResponse, SIGN_OFF } from 'share/mutations/authentication'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'

import { version } from '../../../../package.json'
import './styles.scss'

interface UsermenuProps {
  username?: string
}

const Usermenu: FC<UsermenuProps> = ({ username }) => {
  const history = useHistory()
  const dispatch = useAppDispatch()
  const location = useLocation()

  const [isVisible, setIsVisble] = useState(false)
  const [signOff, { loading: loadingSignOff, data: dataSignOff }] =
    useMutation<SignOffResponse>(SIGN_OFF)

  const handleLogOut = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault()
    await signOff()
  }

  function handleMenuClick(menuItem: string) {
    let urlString = ''
    switch (menuItem) {
      case 'client':
        urlString = '/client'
        break
      case 'user-profile':
        urlString = '/user-profile'
        break
      case 'faqs':
        urlString = '/dashboard/frequentlyaskedquestions'
        break
    }
    if (!location.pathname.includes(urlString)) {
      history.push(urlString)
    }
  }

  const loadingDelay = useLoadingDelay(loadingSignOff)

  useEffect(() => {
    const logOutHelper = async () => {
      if (!loadingSignOff && dataSignOff) {
        await logOut(dispatch)
        history.push('/login')
        window.location.reload()
      }
    }

    logOutHelper()
  }, [loadingSignOff])

  if (loadingDelay) return loadingSpinnerPortal()

  return (
    <div className='ui-usermenu' data-testid='UsermenuID'>
      <div className='ui-usermenu-btn' onClick={() => setIsVisble(!isVisible)}>
        {username}
        <span
          className={`mdi ${isVisible ? 'mdi-chevron-up' : 'mdi-chevron-down'}`}
        ></span>
      </div>
      <div className={`ui-usermenu-slide ${isVisible ? 'show' : 'hidden'}`}>
        <Card>
          <Card.Body className='p-0'>
            <ul onClick={() => setIsVisble(false)}>
              <li onClick={() => handleMenuClick('user-profile')}>
                My Profile
              </li>
              <li onClick={() => handleMenuClick('client')}>My Cases</li>
              <li onClick={() => handleMenuClick('faqs')}>FAQs</li>
            </ul>
            <hr />
            <Button variant='primary' onClick={handleLogOut}>
              Logout
            </Button>
          </Card.Body>
          <div
            className={`ui-app-version ${
              process.env.REACT_APP_ENV === 'production' ? 'prod' : ''
            }`}
          >
            version {version}
          </div>
        </Card>
      </div>
    </div>
  )
}

export default Usermenu
